import { render } from "./ContractProposalSinglePage.vue?vue&type=template&id=4b0081cc&scoped=true"
import script from "./ContractProposalSinglePage.vue?vue&type=script&lang=js"
export * from "./ContractProposalSinglePage.vue?vue&type=script&lang=js"

import "./ContractProposalSinglePage.vue?vue&type=style&index=0&id=4b0081cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0081cc"]])

export default __exports__